import React from "react";
import heroSectionProductImg from "./images/hero-section-poducts-img.webp";
import percentageImg from "./images/percentage.png";
import "./style.css";

function ProductService() {
  return (
    <div>
      <div className="main wrapper">
        {/* <!-- *************** HERO SECTION STARTS *************** --> */}
        <section className="hero-section">
          <img src={heroSectionProductImg} alt="" />
          <div className="hero-section-box">
            <div className="hero-section-text">
              <p>ENABLING ASPIRATIONS.</p>
              <p style={{ fontSize: 50 }}>FINANCING PROGRESS.</p>
            </div>
          </div>
        </section>

        {/* <!-- *************** PARAGRAPH SECTION STARTS *************** --> */}
        <section className="paragraph-section">
          <div className="container">
            <p>
              As an RBI-registered NBFC-ICC, SVCL is expanding access to
              responsible and inclusive finance across homes, small businesses
              and emerging green mobility needs.Our evolving portfolio is
              designed to serve the aspirations of individuals, families,
              entrepreneurs and underserved communities through simple,
              transparent and purpose-led financial solutions. From home
              ownership and MSME growth to green mobility, we aim to make
              finance a meaningful enabler of livelihoods, opportunity and a
              more inclusive India.
            </p>
          </div>
        </section>

        {/* <!-- *************** PRODUCT CARD SECTION STARTS *************** --> */}
        <section className="product-card-section">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-12">
                <div className="product-card">
                  <div className="card-image col-md-3">
                    <h4>Home Loan</h4>
                  </div>
                  <div className="card-body col-md-9">
                    <div className="para-top">
                      <p>
                        Supporting the vision of 'Housing for All' by expanding
                        access to affordable, responsible home finance. Our home
                        loans are designed to help aspiring homeowners,
                        especially underserved and emerging-income families,
                        move closer to owning a safe, secure and dignified home.
                      </p>
                    </div>
                    <div className="card-stats-wrapper">
                      <div className="card-stat">
                        <p>Loan Size</p>
                        <h6>₹ 4,00,000 – ₹ 75,00,000</h6>
                      </div>
                      <div className="card-stat">
                        <p>Tenure</p>
                        <h6>Up to 25 years</h6>
                      </div>
                      <div className="card-stat">
                        <p>Rate of Interest (ROI)</p>
                        <h6>12.5 % - 18 %</h6>
                      </div>
                      <div className="card-stat">
                        <p>Processing fees</p>
                        <h6>
                          Up to 2% <span>+ GST</span>
                        </h6>
                      </div>
                      <div className="card-stat">
                        <p>EMI Payment Frequency</p>
                        <h6>
                          <span>Monthly</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="product-card">
                  <div className="card-image col-md-3">
                    <h4>Loan Against Property</h4>
                  </div>
                  <div className="card-body col-md-9">
                    <div className="para-top">
                      <p>
                        Enabling small MSMEs to unlock the value of their
                        property and access the capital they need to grow,
                        invest and build resilience. With simple, responsible
                        financing, we aim to strengthen India’s small-business
                        ecosystem and support the ambition of inclusive economic
                        growth.
                      </p>
                    </div>
                    <div className="card-stats-wrapper">
                      <div className="card-stat">
                        <p>Loan Size</p>
                        <h6>₹ 3,00,000 – ₹ 50,00,000</h6>
                      </div>
                      <div className="card-stat">
                        <p>Tenure</p>
                        <h6>Up to 15 years</h6>
                      </div>
                      <div className="card-stat">
                        <p>Rate of Interest (ROI)</p>
                        <h6>12 % - 24 %</h6>
                      </div>
                      <div className="card-stat">
                        <p>Processing fees</p>
                        <h6>
                          Up to 4% <span>+ GST</span>
                        </h6>
                      </div>
                      <div className="card-stat">
                        <p>EMI Payment Frequency</p>
                        <h6>
                          <span>Monthly</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="product-card">
                  <div className="card-image col-md-3">
                    <h4>Green Vehicle Loan</h4>
                  </div>
                  <div className="card-body col-md-9">
                    <div className="para-top">
                      <p>
                        Making clean mobility more accessible by financing
                        electric and green vehicles for individuals,
                        entrepreneurs and small businesses. Our green vehicle
                        loans support the shift towards affordable, sustainable
                        transportation while contributing to cleaner communities
                        and a more resilient, low-carbon economy.
                      </p>
                    </div>
                    <div className="card-stats-wrapper">
                      <div className="card-stat">
                        <p>Loan Size</p>
                        <h6>₹ 50,000 – ₹ 200,000</h6>
                      </div>
                      <div className="card-stat">
                        <p>Tenure</p>
                        <h6>12 - 24 months</h6>
                      </div>
                      <div className="card-stat">
                        <p>Rate of Interest (ROI)</p>
                        <h6>Up to 33 %</h6>
                      </div>
                      <div className="card-stat">
                        <p>Processing fees</p>
                        <h6>
                          Up to 3.5% <span>+ GST</span>
                        </h6>
                      </div>
                      <div className="card-stat">
                        <p>EMI Payment Frequency</p>
                        <h6>
                          <span>Twice a Month</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="product-card">
                  <div className="card-image col-md-3">
                    <h4>Green Battery Loan</h4>
                  </div>
                  <div className="card-body col-md-9">
                    <div className="para-top">
                      <p>
                        Our Green Battery Loans support affordable access to
                        clean mobility, while helping accelerate energy
                        transition, lower emissions and a more sustainable
                        future.
                      </p>
                    </div>
                    <div className="card-stats-wrapper">
                      <div className="card-stat">
                        <p>Loan Size</p>
                        <h6>₹ 50,000 – ₹ 70,000</h6>
                      </div>
                      <div className="card-stat">
                        <p>Tenure</p>
                        <h6>12 - 18 months</h6>
                      </div>
                      <div className="card-stat">
                        <p>Rate of Interest (ROI)</p>
                        <h6>Up to 33 %</h6>
                      </div>
                      <div className="card-stat">
                        <p>Processing fees</p>
                        <h6>
                          Up to 4% <span>+ GST</span>
                        </h6>
                      </div>
                      <div className="card-stat">
                        <p>EMI Payment Frequency</p>
                        <h6>
                          <span>Twice a Month</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="product-card">
                  <div className="card-image col-md-3">
                    <h4>Income Generating Loan</h4>
                  </div>
                  <div className="card-body col-md-9">
                    <div className="para-top">
                      <p>
                        We empower rural women through loans for income
                        generation in activities like agriculture, dairy,
                        trading, kirana stores and tailoring businesses.
                      </p>
                    </div>
                    <div className="card-stats-wrapper">
                      <div className="card-stat">
                        <p>Loan Size</p>
                        <h6>₹ 15,000 – ₹ 100,000</h6>
                      </div>
                      <div className="card-stat">
                        <p>Tenure</p>
                        <h6>12 - 36 months</h6>
                      </div>
                      <div className="card-stat">
                        <p>Rate of Interest (ROI)</p>
                        <h6>26 - 36 %</h6>
                      </div>
                      <div className="card-stat">
                        <p>Processing fees</p>
                        <h6>
                          Up to 4% <span>+ GST</span>
                        </h6>
                      </div>
                      <div className="card-stat">
                        <p>EMI Payment Frequency</p>
                        <h6>
                          <span>Weekly – Biweekly – Monthly</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="product-card">
                  <div className="card-image col-md-3">
                    <h4>Micro Business Loan (Dukaan Loan)</h4>
                  </div>
                  <div className="card-body col-md-9">
                    <div className="para-top">
                      <p>
                        We provide micro business loans in rural and semi-urban
                        areas under promoting expansion of livelihood and/or
                        business.
                      </p>
                    </div>
                    <div className="card-stats-wrapper">
                      <div className="card-stat">
                        <p>Loan Size</p>
                        <h6>₹ 75,000 – ₹ 200,000</h6>
                      </div>
                      <div className="card-stat">
                        <p>Tenure</p>
                        <h6>12 - 36 months</h6>
                      </div>
                      <div className="card-stat">
                        <p>Rate of Interest (ROI)</p>
                        <h6>Up to 33 %</h6>
                      </div>
                      <div className="card-stat">
                        <p>Processing fees</p>
                        <h6>
                          Up to 4% <span>+ GST</span>
                        </h6>
                      </div>
                      <div className="card-stat">
                        <p>EMI Payment Frequency</p>
                        <h6>
                          <span>Biweekly</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-12">
                <div className="product-card">
                  <div className="card-image col-md-3">
                    <h4>Emergency Loan</h4>
                  </div>
                  <div className="card-body col-md-9">
                    <div className="para-top">
                      <p>
                        In times of unforeseen events such as health
                        emergencies, natural disasters, and family bereavements,
                        we provide emergency loans tailored to meet urgent
                        financial needs. Our commitment to empowering women
                        drives us to offer accessible financial solutions that
                        bring peace of mind during critical times.
                      </p>
                    </div>
                    <div className="card-stats-wrapper">
                      <div className="card-stat">
                        <p>Loan Size</p>
                        <h6>₹ 5000</h6>
                      </div>
                      <div className="card-stat">
                        <p>Tenure</p>
                        <h6>6 months</h6>
                      </div>
                      <div className="card-stat">
                        <p>Rate of Interest (ROI)</p>
                        <h6>26 - 29 %</h6>
                      </div>
                      <div className="card-stat">
                        <p>Processing fees</p>
                        <h6>
                          1.5% <span>+ GST</span>
                        </h6>
                      </div>
                      <div className="card-stat">
                        <p>EMI Payment Frequency</p>
                        <h6>
                          <span>Weekly – Biweekly – Monthly</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            <h5
              style={{
                marginTop: 10,
                alignItems: "center",
                justifyContent: "flex-start",
                display: "flex",
              }}
            >
              <img
                src={percentageImg}
                style={{ width: 25, height: 25, margin: 10 }}
              />
              <span style={{ fontSize: 14, lineHeight: 1.5 }}>
                The applicable rate of interest shall be determined at the sole
                discretion of the Company based on its internal credit
                underwriting and risk assessment parameters. The final rate of
                interest may vary from customer to customer.
              </span>
            </h5>
          </div>
        </section>
      </div>
    </div>
  );
}

export default ProductService;
